import { ChponkView } from 'desktop/es6/chponk/chponk-view'
import { ChponkPackView } from 'desktop/es6/chponk/chponk-pack-view'
import { View } from 'es6/components/view'
import $ from 'init/jquery'
import { Defaults } from 'es-decorators'

/**
 * Общий вид баннеров
 */

@Defaults({
  el: 'body',
  chponckSelector: '.chponck-item',
  chponckPackSelector: '.chponk-item-pack',
  additionalOptions: ['mainWindow', 'eventBus', 'chponckSelector', 'chponckPackSelector'],
})
export class ChponkCommonView extends View {
  /**
   * @inheritDoc
   */
  run () {
    this.childViews.banners = []
    this.childViews.packs = []
    $('.b-home-chponck').stop(true).delay(200).animate({
      opacity: 1,
    }, 400)
    $('.wait-sec-pls').stop(true).delay(200).animate({
      opacity: 0,
    }, 400)
    let $chponcksAndPacks = this.$([])
    if (this.chponckSelector) {
      let chponckSelector = this.chponckSelector
      if (this.chponckPackSelector) {
        chponckSelector = `:not(${this.chponckPackSelector}) > ${chponckSelector}`
      }
      $chponcksAndPacks = $chponcksAndPacks.add(chponckSelector)
    }
    if (this.chponckPackSelector) {
      $chponcksAndPacks = $chponcksAndPacks.add(this.chponckPackSelector)
    }
    if ($chponcksAndPacks.length) {
      // для каждого баннера создаём свой объект
      $chponcksAndPacks.each((index, item) => {
        const $item = $(item)
        let pushTo
        let options
        let ChponckConstructor
        if ($item.is(this.chponckSelector)) {
          pushTo = this.childViews.banners
          options = {
            el: $item,
            mainWindow: this.mainWindow,
            eventBus: this.eventBus,
          }
          ChponckConstructor = ChponkView
        }
        if ($item.is(this.chponckPackSelector)) {
          pushTo = this.childViews.packs
          options = {
            el: $item,
            mainWindow: this.mainWindow,
            eventBus: this.eventBus,
            chponckSelector: this.chponckSelector,
          }
          ChponckConstructor = ChponkPackView
        }
        pushTo && options && ChponckConstructor && pushTo.push(new ChponckConstructor(options))
      })
    }

    // следим за переключением табов на главной
    this.listenTo(this.eventBus, 'tabs.home.change', this.changeWindow)
  }
  /**
   * Из-за эффектов появления баннер занимает свою позицию не сразу.
   *
   * Код ниже реагирует на событие `window.scroll` и определяет попадает ли
   * баннер в поле видимости посетителя.
   */
  changeWindow () {
    setTimeout(() => {
      this.mainWindow.trigger('window.scroll', window)
    }, 100)
  }
}
